<div class="section">
    <div class="title-row">
        <div class="left-elements">
            <label>{{ neighborhoodEnrichmentEntry.name }}</label>
            <button
                (click)="downloadData()"
                class="icon-button"
                [attr.aria-label]="'Download data'"
                [title]="'Download data'"
            >
                <cds-icon shape="download"></cds-icon>
            </button>
        </div>
    </div>
    <img class="result-image" [src]="neighborhoodEnrichmentEntry.img" />
    <div>
        <div class="button-container">
            <button (click)="toggleDetails()" type="button" class="transparent-button">
                <div class="chevrons">
                    <ng-container *ngIf="detailsVisible; then chevronDown"></ng-container>
                    <ng-container *ngIf="!detailsVisible; then chevronRight"></ng-container>
                    <ng-template #chevronRight>
                        <img src="../../../../assets/icons/chevron-right.svg" alt="chevron up" />
                    </ng-template>
                    <ng-template #chevronDown>
                        <img src="../../../../assets/icons/chevron-down.svg" alt="chevron down" />
                    </ng-template>
                </div>
                Details
            </button>
        </div>
        <div class="details" *ngIf="detailsVisible">
            <div class="detail-entry">
                Keep unassigned: {{ neighborhoodEnrichmentEntry.details.keepBackground }}
            </div>
            <div class="detail-entry">
                Radius [µm]: {{ neighborhoodEnrichmentEntry.details.radius }}
            </div>
            <div class="detail-entry">
                Selections:
                {{ formatSelections(neighborhoodEnrichmentEntry.details.selections) }}
            </div>
        </div>
    </div>
</div>
